import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LotItemManufacturerLotGroup } from '@app/models/inventory/lot-item-manufacturer-lot-group';
import { LotItemSearchCommand } from '@app/models/inventory/lot-item-search-command';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LotItemProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/lot-item';

  public searchGroupedByManufacturerLot(command: LotItemSearchCommand): Observable<ApiResponse<LotItemManufacturerLotGroup[]>> {
    return this.httpClient.post<ApiResponse<LotItemManufacturerLotGroup[]>>(`${this.baseUrl}/search/grouped-by-manufacturer-lot`, command);
  }
}
